import fadeInAnimation from "./home-fade-in-animations.js";
import { escapeHtml, getNewsCardLayout } from "./archive-card-layout.js";

class NewsLoader {
  constructor() {
    this.loadMoreButton = document.querySelector("#see-more-news");
    this.contentContainer = document.querySelector(".news-content-container");
    this.currentPage = 1;
    this.perPage = 6;
    this.assetsBase = document.documentElement.dataset.assetsBase || "assets";
    this.config = window.BBDO_CONFIG || {};
    this.totalPages = Number(
      document.documentElement.dataset.newsTotalPages || 1,
    );

    this.init();
  }

  init() {
    if (!this.loadMoreButton || !this.contentContainer) return;

    this.checkInitialState();
    this.bindEvents();
  }

  bindEvents() {
    this.loadMoreButton.addEventListener("click", (event) =>
      this.handleLoadMore(event),
    );
  }

  async checkInitialState() {
    this.updateButtonVisibility(this.totalPages);
  }

  async handleLoadMore(event) {
    event.preventDefault();
    this.currentPage++;

    try {
      const { totalPages, data } = await this.fetchNews(this.currentPage);
      this.renderNews(data);
      this.updateButtonVisibility(totalPages);
    } catch (error) {
      console.error("Eroare la încărcarea noutăților:", error);
    }
  }

  async fetchNews(page) {
    const endpoint = this.config.newsEndpoint
      ? `${this.config.newsEndpoint}${this.config.newsEndpoint.includes("?") ? "&" : "?"}page=${page}`
      : `${this.assetsBase}/data/news-page-${page}.json`;
    const response = await fetch(endpoint, {
      headers: this.config.restNonce
        ? { "X-WP-Nonce": this.config.restNonce }
        : {},
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const responseData = await response.json();
    return {
      data: Array.isArray(responseData)
        ? responseData
        : responseData.items || [],
      totalPages: responseData.totalPages || this.totalPages,
    };
  }

  updateButtonVisibility(totalPages) {
    if (this.currentPage >= totalPages) {
      this.loadMoreButton.hidden = true;
    }
  }

  formatDate(dateString) {
    return new Date(dateString).toLocaleDateString("ro-RO", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  createNewsCard(item, index) {
    const layout = getNewsCardLayout(index, item.layout);
    const isHorizontal = layout === "horizontal";
    const isExternal = item.external !== false;
    const fields = item.acf || {};
    const title = fields.main_title || "Fără titlu";
    const image = fields.news_image || "";
    const link = fields.news_url || item.link || "#";
    const externalAttributes = isExternal
      ? ' target="_blank" rel="noopener noreferrer"'
      : "";

    return `
			<a href="${escapeHtml(link)}" class="card-news ${isHorizontal ? "horizontal" : ""} news-page" data-card-layout="${layout}"${externalAttributes}>
				<div class="card-news__image">
					${image ? `<img src="${escapeHtml(image)}" alt="Imagine ${escapeHtml(title)}" loading="lazy" />` : ""}
				</div>
				<div class="card-news__content">
					<div class="card-news__head">
						<h3>${escapeHtml(title)}</h3>
						<svg width='19' height='19' viewBox='0 0 19 19' fill='none' aria-hidden='true'>
							<path d='M1 17.3704L18 1M18 1V11.6852M18 1H7' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
						</svg>
					</div>
					<span class="news-date">${escapeHtml(this.formatDate(item.date))}</span>
					<p>${escapeHtml(fields.main_paragraph || "")}</p>
				</div>
			</a>
		`;
  }

  renderNews(data) {
    const existingGrids = this.contentContainer.querySelectorAll(
      ".news-grid-container[data-animation]",
    );
    existingGrids.forEach((grid) => grid.removeAttribute("data-animation"));

    const grid = `
			<div class="news-grid-container" data-animation="fade-in">
				${data.map((item, index) => this.createNewsCard(item, index)).join("")}
			</div>
		`;

    this.contentContainer.insertAdjacentHTML("beforeend", grid);
    fadeInAnimation();
  }
}

export default function initNews() {
  return new NewsLoader();
}
